import React, { useContext, useEffect, useState } from 'react';
import { StateController } from './../../App';
import Container from '../../layouts/Container/Container';
// import PrimaryBanner from '../molecules/PrimaryBanner';
import AwardsGallery from '../organisms/AwardsGallery';
import Preloader from '../atoms/Preloader';
import { getMaximumBlock } from '../../utils/functions';
import BannerImage from '../molecules/BannerImage';
// import { sendDataLayer } from '../../utils/functions';
import { Link } from 'react-router-dom';
import useWidth from '../../hooks/useWidth';
import CustomModal from '../molecules/CustomModal';

function Awards() {
  const [awards, setAwards] = useState(false);
  const [canRedem, setCanRedem] = useState(false);
  const [showModalSoulOut, setShowModalSoulOut] = useState(null);
  const [showModal, setShowModal] = useState(false)
  const { context } = useContext(StateController);
  //const segment = context?.user?.segment ? context.user.segment : '0';
  const isWinner = context?.tracing?.winner_1 === 1;
  const { width } = useWidth();

  useEffect(() => {
    if (context && context.awards) {

      const filtered = []
      const listAwards = context.awards[`block_${getMaximumBlock(context.block, context.blocks)}`].awards

      if (context.user.segment == "1") {
        // activos
        for (let i = 0; i < listAwards.length; i++) {
          const award = listAwards[i];
          filtered.push(award)
        }
      }
      if (context.user.segment == "0") {
        console.log("awards")
        console.log(listAwards)
        // inactivos
        for (let i = 0; i < listAwards.length; i++) {
          const award = listAwards[i];
          if (
            award.id != 1 ||  award.id != 7
          ) {
            filtered.push(award)
          }
        }
      }

      setAwards(filtered)
      setCanRedem(
        context.awards[`block_${getMaximumBlock(context.block, context.blocks)}`].canRedem
      );
    }
  }, [context]);

  useEffect(() => {
    const segment = context?.user?.segment
    if (segment == null) return

    const isSoulOut = false;
    setShowModalSoulOut(isSoulOut)
    setShowModal(isSoulOut)
  }, [context?.user?.segment])


  // Los tags ("Agotado" / "Por tiempo limitado") solo tienen sentido mientras el
  // usuario todavia pueda canjear. Si ya hizo una redencion y no le quedan mas
  // disponibles, el catalogo se muestra sin tags.
  const hasRedeemed = Array.isArray(context?.redemtions) && context.redemtions.length > 0;
  const noRedemtionsLeft = hasRedeemed && !canRedem;
  const showSpecialTags = isWinner && !noRedemtionsLeft;

  console.log('hasRedeemed', hasRedeemed)

  // const dataLayerAllied = (e, content, link) => {
  //   sendDataLayer({
  //     datalayer: {
  //       event: 'alliances',
  //       text: content,
  //       link: link
  //     },
  //     repeat: true
  //   });
  // }
  
  return (
    <>
      <div className='mc-page awards slow_ani'>

        {/* <PrimaryBanner image="banner.png" /> */}
        <Container>
          <div className='mc-title-award-container'>
            <div className='mc-title-award-container--title'>
              {width < 768 ? <h1>Catálogo de <br/>e-Gift Cards</h1> : <h1>Catálogo de e-Gift Cards</h1> }
            </div>
            {context &&
              <div>
                {hasRedeemed ?
                  <p>
                    Ya redimiste tu bono.
                  </p>
                : (
                    (awards && canRedem) ? (
                    <p>
                        {width < 768 ? <><strong>Buenas noticias!</strong><br/> El botón de canjear ya está disponible para ti.</> : <><strong>¡Buenas noticias!</strong> El botón de canjear ya está disponible para ti.</> }                     
                      </p>
                    ) : (
                      <p>
                        {width < 768 ? <><strong>Aún no has alcanzado tu objetivo</strong><br/> El botón de canjear estará disponible cuando lo hagas.</> : <><strong>Aún no has alcanzado tu objetivo</strong> El botón de canjear estará disponible cuando lo hagas.</> }
                        <Link className='link' to={'/GanaConMastercardDebit/progreso'}></Link></p>
                    )
                  )
                }
              </div>
            }
          </div>
        </Container>
        {showModalSoulOut === false &&
          <Container>
            {awards ? (
              <AwardsGallery
                awardBoxType={2}
                itemsPerLine={3}
                limit={false}
                limitButtonText="Ver más comercios"
                showStock={true}
                showSpecialTags={showSpecialTags}
                list={awards}
                steps={false}
                canRedem={!context.user.segment == "0" ? canRedem : false}
                // twoStepAuth={true}
                redemtionText="Canjear"
                termText="Términos y condiciones"
                termLink="/GanaConMastercardDebit/terminos-y-condiciones"
              />
            ) : (
              <Preloader type="section" invert />
            )}
          </Container>
        }
      </div>

      {showModalSoulOut && (
        <CustomModal
          title={`¡Sigue participando por el premio mayor!`}
          desc={
              "Estas e-Gift Cards se han agotado.<br/>Sigue cumpliendo tu meta y suma oportunidades para ganar un <strong>viaje doble a São Paulo</strong> para vivir el concierto del tour <strong>“Debí tirar más fotos“.</strong>"
          }
          cta="Aceptar"
          isAwardTerms={true}
          winner={showModalSoulOut}
          show={showModal}
          setShowModal={setShowModal}
          className="awards_modal"
        />
      )}
      
      {context && 
        <BannerImage
          textLink={'*Aplican Términos y Condiciones.'}
          link={'/GanaConMastercardDebit/terminos-y-condiciones'}
          className='container'
          textButton={'Cómo ganar'}
          linkButton={'/GanaConMastercardDebit/premio-mayor'}
        >
          <h2>
            ¿Te vas a perder Turquía? 
          </h2>
          <p>Participa por un viaje doble a Turquía y recorre Estambul, Capadocia y Ankara. Cada meta cumplida te acerca al premio mayor.</p>
        </BannerImage>
      }


      {/* <div className='mc-page__progress--extra'>
        <Container>
          <div className='mc-page__progress--extra__t1'>
            Aprovecha estas alianzas que <strong>te ayudarán a cumplir tu meta</strong>
          </div>
          <div className='mc-page__progress--extra__t2'>
            <div className='mc-page__progress--extra__t2--item' onClick={(e) => dataLayerAllied(e, "Carl's JR", '/premios')}>
              <div className='mc-page__progress--extra__t2--item__image border_ajuste'>
                <img src="/assets/images/combo_classic_border.png" alt="" />
              </div>
              <div className='mc-page__progress--extra__t2--item__labels'>
                <h3>Carl{`'`}s JR</h3>
                <p>Con tus tarjetas Mastercard disfruta del <strong>Classic Combo por solo $4,90</strong>. <span><br /> <br />(Precio normal $7,30)</span></p>
              </div>
            </div>
            <div className='mc-page__progress--extra__t2--item' onClick={(e) => dataLayerAllied(e, "Carl's JR", '/premios')}>
              <div className='mc-page__progress--extra__t2--item__image border_ajuste'>
                <img src="/assets/images/super_duo_border.png" alt="" />
              </div>
              <div className='mc-page__progress--extra__t2--item__labels'>
                <h3>Carl{`'`}s JR</h3>
                <p><strong>Disfruta del Super Duo a $9,90</strong> usando tus tarjetas Mastercard. <span> <br /> <br />(Precio normal $11,90)</span></p>
              </div>
            </div>
          </div>
        </Container>
      </div> */}
    </>
  );
}

export default Awards;
